import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";

import { TranslateModule } from "@ngx-translate/core";

import { TAutoLogoutDialogConfig } from "@app/core/auto-logout/components/auto-logout-dialog/auto-logout-dialog.type";
import { DestroyService } from "@app/core/services/destroy.service";

@Component({
  selector: "under-ui-auto-logout-dialog",
  template: `
    <mat-dialog-content>
      {{ 'CORE.AUTO_LOGOUT.MESSAGE' | translate: { duration: data.durationTime } }}
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button class="accent" (click)="onStayLoggedIn()">
        {{ 'CORE.AUTO_LOGOUT.BTN' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  imports: [
    MatDialogContent,
    MatButton,
    MatDialogActions,
    TranslateModule
  ],
  standalone: true
})
export class AutoLogoutDialogComponent {

  constructor(
    private readonly matDialogRef: MatDialogRef<AutoLogoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: TAutoLogoutDialogConfig,
  ) {}

  onStayLoggedIn(): void {
    this.matDialogRef.close(true);
  }
}
